import { MEDIA_URL } from './config';

export function resolveMediaUrl(imageUrl, mediaUrl = MEDIA_URL) {
    if (!imageUrl || !mediaUrl) return imageUrl;

    try {
        const sourceUrl = new URL(imageUrl, mediaUrl);

        if (!sourceUrl.pathname.startsWith('/media/')) return imageUrl;

        const publicUrl = new URL(mediaUrl);
        publicUrl.pathname = sourceUrl.pathname;
        publicUrl.search = sourceUrl.search;
        publicUrl.hash = sourceUrl.hash;
        return publicUrl.toString();
    } catch (error) {
        return imageUrl;
    }
}
